'use client';

import { ApolloProvider } from '@apollo/client';
import { useApolloClient } from '@crehana/apollo-client';
import { CrehanaLayout } from '@crehana/layouts';
import { jsx as _jsx } from "react/jsx-runtime";
export var CommonLayouts = function CommonLayouts(_ref) {
  var children = _ref.children,
    countryCode = _ref.countryCode,
    organizationSlug = _ref.organizationSlug,
    _ref$authProvider = _ref.authProvider,
    authProvider = _ref$authProvider === void 0 ? true : _ref$authProvider;
  var apolloClient = useApolloClient(
  // @ts-ignore
  null, countryCode, null);
  if (authProvider) {
    return /*#__PURE__*/_jsx(CrehanaLayout, {
      renderCookiesBanner: false,
      organizationSlug: organizationSlug,
      amplitudeApiKey: process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(ApolloProvider, {
    client: apolloClient,
    children: children
  });
};